import { gql } from '@apollo/client';

const searchCar = {
  SEARCH_CAR: gql`
    query GetSearchCar($filters: Filters) {
      searchCar(filters: $filters)
    }
  `,
};

export default searchCar;
